// Gerado por scripts/build-icons.mjs — não editar manualmente.
import { createBankIcon } from "../createBankIcon";

/** Banco Pine — COMPE 643 */
export const Pine = createBankIcon({
  name: "Banco Pine",
  slug: "pine",
  compe: "643",
  color: "#661739",
  viewBox: "0 0 100.03096 100.03096",
  html: "<rect\n     style=\"fill:#661739;fill-opacity:1\"\n     id=\"pine_rect1\"\n     width=\"100.03096\"\n     height=\"100.03096\"\n     x=\"0\"\n     y=\"0\" />\n  <g transform=\"translate(-8.6292,-42.7025) scale(0.04711)\">\n    <path d=\"m 1389.98212774,2200.72646336 l 235.18178024,183.90744328 l 235.18178024,-183.90744328 L 1860.34568822,2055.2747728 L 1625.16390798,2252.00080032 L 1389.98212774,2055.2747728 Z m 0,-649.56213608 l 0,145.45169056 l 235.18178024,183.90744328 l 235.18178024,-183.90744328 l 0,-145.45169056 l -235.18178024,196.72602752 z M 629.23839366,2055.53637656 l 0,145.45169056 l 235.18178024,183.90744328 l 235.18178024,-183.90744328 l 0,-145.45169056 l -235.18178024,196.72602752 z\" style=\"fill:#ffffff\" fill-rule=\"evenodd\" />\n  </g>",
});
